import React from "react";

const TermsConditions = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f7f7f7",
        // padding: "32px 20px",
      }}
    >
      <div
        className="terms-conditions-content"
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          padding: "28px 24px",
          boxShadow: "0 6px 24px rgba(0, 0, 0, 0.08)",
          color: "#1f2937",
          lineHeight: 1.7,
        }}
      >
        <h1 style={{ marginTop: 0, fontSize: "32px", color: "#111827" }}>
          U4U.app | Behaviour Agreement
        </h1>
        <p>
          <strong>Our Mission</strong>
        </p>
        <p>
          U4U gives girls a place to have fun, connect, belong, grow and be
          boosted to achieve their fullest potential.
        </p>

        <p>
          <strong>Support and Safety</strong>
        </p>
        <p>
          The U4U Support team and each house lead carefully examines reports of
          rule violations submitted by users, technology guards, and mandated
          reporters. We may take necessary measures such as issuing warnings,
          deleting content, suspending or terminating accounts or servers, and
          notifying law enforcement when needed.
        </p>
        <p>
          Please report any content or behavior that goes against our Terms and
          Conditions to your house lead, U4U Support, or the{" "}
          <a href="mailto:team@u4uteen.com">U4U management team</a>.
        </p>

        <h2>Community Commitment</h2>
        <p>
          The U4U community aims to provide a safe and supportive environment
          where teen girls and demi-girls can celebrate their true, unique
          selves.
        </p>

        <h3>Positivity and Kindness</h3>
        <ul>
          <li>
            Spread positivity and kindness, even on difficult days.
          </li>
          <li>
            No bullying or degrading comments about culture, race, religion,
            sexual orientation, gender, health, or disability.
          </li>
          <li>
            We take threats, harassment, and hate speech seriously.
          </li>
        </ul>

        <h3>Important Requirements</h3>
        <ul>
          <li>
            Your house feed is private. Do not screenshot or share trusted
            private information.
          </li>
          <li>
            Do not ask for or share private contact details through the app.
          </li>
          <li>
            Check uploaded photos to avoid exposing personal information.
          </li>
          <li>
            In urgent crises, call 911 instead of posting in the community.
          </li>
        </ul>

        <h2>Not Accepted in U4U</h2>
        <p>
          U4U is a supportive and respectful community. Violations may result in
          warnings or account termination.
        </p>

        <h3>Nudity</h3>
        <p>
          Do not share nude photos or illustrations of yourself or others. We
          report child sexual abuse material and relevant evidence to legal
          authorities.
        </p>

        <h3>Self Harm</h3>
        <p>
          Do not promote or encourage self-harm, suicide, or disordered eating.
        </p>

        <h3>Hate Speech</h3>
        <ul>
          <li>
            Zero tolerance for hate speech, bullying, or attacks on protected
            groups.
          </li>
          <li>
            Illegal or prohibited content may be removed and reported.
          </li>
        </ul>

        <h3>Disinformation</h3>
        <p>
          Do not share misleading or deceptive information. If you see content
          that violates guidelines, report it at{" "}
          <a href="mailto:team@u4uteen.com">team@u4uteen.com</a>.
        </p>

        <h3>Do Not Be Mean</h3>
        <p>
          Abusive behavior toward housemates, house leads, or U4U staff may
          lead to account termination.
        </p>

        <h2>Report Bad Behavior</h2>
        <p>
          If you see behavior that concerns you or violates these terms, please
          report it to Support or email{" "}
          <a href="mailto:team@u4uteen.com">team@u4uteen.com</a>.
        </p>

        <h2 >U4U Terms of Use</h2 >

        <h5>Last Updated: March 4, 2026</h5>



<h2 >IMPORTANT NOTICE</h2>

<p>Please read these Terms of Use (or "Agreement", "Terms") carefully. This Agreement is a legally binding contract between you and U4U. Access to and use of U4U App's products and services is expressly conditioned upon acceptance of this Agreement. If you do not agree to these Terms, you will not be able to access the U4U App or its products or services.</p>



<p>PLEASE CAREFULLY READ THE BINDING ARBITRATION CLAUSE AND CLASS ACTION WAIVER IN SECTION 24. IT AFFECTS HOW DISPUTES ARE RESOLVED BETWEEN YOU AND U4U AND INFORMS YOU OF YOUR OPT-OUT RIGHTS.</p>



<p>NOTE: Depending on your location, you may have rights under applicable local laws that cannot be waived. Nothing in this Agreement limits any such rights under those laws.</p>



<h2 >TABLE OF CONTENTS</h2>

<ol style={{ listStyleType: "decimal", paddingLeft: "20px" }} >
<li>Introduction</li>
<li>Who Are We?</li>
<li>When Do These Terms Apply?</li>
<li>Who Can Access U4U App?</li>
<li>App, Features and Content Are Not Intended to Provide Medical Advice, Diagnosis, or Treatment</li>
<li>Registration and Eligibility</li>
<li>Your Use of the U4U App</li>
<li>Export and Economic Sanctions Control</li>
<li>Limited License to the App</li>
<li>License to User Content</li>
<li>Use at Your Own Risk</li>
<li>Use by Minors Disclaimer</li>
<li>Subscriptions and Billing</li>
<li>U4U Houses</li>
<li>House Leads: Roles, Limitations, and Access to User Information</li>
<li>Crisis Protocol and Emergency Resources</li>
<li>Mandatory Reporting Obligations</li>
<li>Privacy in U4U Houses and Screenshot Limitations</li>
<li>Parent Subscribers and Dashboard Access</li>
<li>Passwords</li>
<li>Warranty Disclaimer</li>
<li>Limitation of Liability</li>
<li>Use of Mobile Devices</li>
<li>Third-Party Services and Links</li>
<li>Your Feedback</li>
<li>Enforcement Rights</li>
<li>Maintenance and Updates</li>
<li>Indemnity</li>
<li>Dispute Resolution and Arbitration</li>
<li>Governing Law</li>
<li>Notice and Takedown Procedures</li>
<li>Data Retention and Account Termination</li>
<li>Other Provisions</li>
<li>Questions, Complaints and Comments</li>
</ol>



<h2 >01 INTRODUCTION</h2>

<p>1.1. Please read the Terms of Use (or "Agreement", "Terms" for short) carefully. This Agreement is a legally binding contract between you and U4U. Access to and use of U4U App's products and services is expressly conditioned upon acceptance of this Agreement. If you do not agree to these Terms, you will not be able to access the U4U App or its products or services.</p>

<p>1.2. PLEASE CAREFULLY READ THE BINDING ARBITRATION CLAUSE AND CLASS ACTION WAIVER IN SECTION 29. IT AFFECTS HOW DISPUTES ARE RESOLVED BETWEEN YOU AND U4U AND INFORMS YOU OF YOUR OPT-OUT RIGHTS.</p>

<p>NOTE: Depending on your location, you may have rights under applicable local laws that cannot be waived. Nothing in this Agreement limits any such rights under those laws.</p>

<p>1.3. By creating an account or accessing or using the App, you acknowledge that you accept and agree to be bound by the terms of this Agreement. IF YOU DO NOT AGREE TO THESE TERMS, YOU MAY NOT ACCESS OR USE THE APP.</p>

<p>1.4. In addition to these Terms, the following terms apply and form part of your contract with us: our <a href="https://u4u.app/privacy-policy" target="_blank" rel="noreferrer noopener" >Privacy Policy</a> available on our website ("Privacy Policy") and our Community Guidelines.</p>

<p>1.5. By accepting this agreement, you affirm that you: (a) have read this Agreement and agree to abide by its terms and the other terms incorporated into it by reference; (b) have reviewed and consent to the Privacy Policy; and (c) agree not to use the respective service or content for any other purposes as described in these Terms.</p>



<h2 >02 WHO ARE WE?</h2>

<p>2.1. We are U4UTeen, a company incorporated in the United States, company number 12898410. So we will refer to ourselves throughout this Agreement as "U4U", "Company", "we" or "us".</p>

<p>2.2. The registered office of U4UTeen is 101 Primrose Path, Mill Valley, CA 94941.</p>



<h2 >03 WHEN DO THESE TERMS APPLY?</h2>

<p>3.1. These Terms apply to all use of the U4U mobile application ("the App"), the websites (u4uteen.com, etc.), and all related services, features and content offered by U4U.</p>



<h2 >04 WHO CAN ACCESS U4U APP?</h2>

<h3 >Age Requirements</h3>

<p>4.1. MINIMUM AGE: You must be at least 11 years old to use U4U and access U4U's content.</p>

<p>4.2. USERS UNDER 13 REQUIRE PARENTAL CONSENT: If you are under 13 years of age, your parent or legal guardian MUST provide verifiable parental consent before you can create an account, as required by the Children's Online Privacy Protection Act (COPPA).</p>

<p>4.3. TARGET AUDIENCE: U4U content and features are designed specifically for girls ages 11-18. Users over 18 may not create accounts or participate in U4U Houses, with the exception of House Leads.</p>



<h3 >Verifiable Parental Consent for Users Under 13</h3>

<p>4.4. Before a child under 13 can create a U4U account, we require verifiable parental consent through one of the following methods:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Parent provides consent through a verification email sent to the parent's email address, which includes identity verification steps</li>
<li>Parent completes and submits a signed consent form</li>
<li>Other methods as permitted under COPPA regulations</li>
</ul>

<p>4.5. During the consent process, parents will be informed of:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>What information we collect from their child (including messages, mood tracking, activity responses, photos, and interactions in Houses)</li>
<li>How we use that information</li>
<li>Who has access to it (House Leads, U4U staff, other house members within the child's assigned House)</li>
<li>Their rights to review, modify, and delete their child's information at any time
&nbsp;</li>
</ul>

<h2 >Parental Rights (Users Under 13)</h2>

<p>4.6. Parents and legal guardians of users under 13 have the right to:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Review all personal information collected from their child</li>
<li>Request deletion of their child's personal information</li>
<li>Refuse to permit further collection of their child's information</li>
<li>Request that we stop sending notifications to their child</li>
<li>Revoke consent and request account termination</li>
</ul>

<p>4.7. To exercise these rights, parents may contact us at <a data-auto-recognition="true" href="mailto:team@u4uteen.com" >team@u4uteen.com</a> with:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Parent's name and contact information</li>
<li>Child's username and/or email address associated with the account</li>
<li>Specific request (review, delete, revoke consent, etc.)</li>
<li>Verification of parental status (may be required)</li>
</ul>

<p>We will respond to parental requests within 30 days.</p>

<p>&ZeroWidthSpace;&ZeroWidthSpace;</p>

<h2>Age Verification</h2>

<p>4.8. During account creation, you must provide your date of birth. We use this information to:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Verify you meet minimum age requirements</li>
<li>Determine whether parental consent is required</li>
<li>Provide age-appropriate content and features</li>
</ul>

<p>Providing false age information violates these Terms and may result in immediate account termination and deletion of data.</p>



<h2>Enforcement</h2>

<p>4.9. We do not knowingly collect personal information from children under 11 without proper age screening.</p>

<p>4.10. We do not allow people to use the App and access U4U if they are younger than 11 or if they are over 18 (as the platform is designed for teen girls ages 11-18).</p>

<p>4.11. If you are aware of anyone that does not comply with these limitations, please contact us at <a data-auto-recognition="true" href="mailto:team@u4uteen.com" >team@u4uteen.com</a>, and we will take the necessary steps to verify age and delete or terminate their account if they do not meet requirements.</p>



<h2 >05 APP, FEATURES AND CONTENT ARE NOT INTENDED TO PROVIDE MEDICAL ADVICE, DIAGNOSIS, OR TREATMENT</h2>

<p>5.1. CRITICAL DISCLAIMER:</p>

<p>THE COMPANY IS NOT A LICENSED MEDICAL CARE PROVIDER AND THE APP IS NOT INTENDED TO REPLACE PROFESSIONAL MEDICAL ADVICE OR DIAGNOSE, TREAT OR MANAGE ANY ILLNESS OR MEDICAL CONDITION. U4U PROVIDES PEER SUPPORT, WELLNESS ACTIVITIES, AND EDUCATIONAL CONTENTâ€”NOT MEDICAL OR MENTAL HEALTH TREATMENT.</p>

<p>HOUSE LEADS ARE TRAINED FACILITATORS BUT ARE NOT LICENSED THERAPISTS, COUNSELORS, PSYCHOLOGISTS, PSYCHIATRISTS, SOCIAL WORKERS, OR MEDICAL PROFESSIONALS.</p>

<p>THE APP IS NOT A MEDICAL DEVICE. MOOD TRACKING AND WELLNESS FEATURES ARE FOR SELF-AWARENESS AND PERSONAL GROWTH, NOT CLINICAL ASSESSMENT OR DIAGNOSIS.</p>

<p>PLEASE CONSULT WITH A LICENSED PHYSICIAN, THERAPIST, OR OTHER QUALIFIED HEALTHCARE PROVIDER BEFORE MAKING ANY DECISIONS OR TAKING ANY ACTIONS THAT MAY AFFECT YOUR HEALTH AND SAFETY. NEVER DISREGARD PROFESSIONAL MEDICAL ADVICE OR DELAY IN SEEKING IT BECAUSE OF SOMETHING YOU HAVE READ IN CONNECTION WITH THE APP.</p>

<p>IF YOU THINK YOU HAVE A MEDICAL OR MENTAL HEALTH EMERGENCY, CALL 911 OR YOUR LOCAL EMERGENCY SERVICES IMMEDIATELY. DO NOT RELY ON U4U HOUSES OR HOUSE LEADS FOR CRISIS INTERVENTION.</p>

<p>5.2. WE DISCLAIM LIABILITY FOR ANY ERRORS OR OMISSIONS, OR FOR UNINTENDED TECHNICAL INACCURACIES, OR TYPOGRAPHICAL ERRORS IN THE PROVIDED MATERIALS, AS WELL AS ANY VIOLATION OF ANY ETHICAL OR MORAL STANDARDS APPLICABLE IN YOUR COMMUNITY TO SEXUAL EDUCATION AND RELATED MATERIALS.</p>

<p>5.3. SOME TRANSLATIONS ON U4U'S APP OR WEBSITE ARE POWERED BY MACHINE LEARNING AND ARTIFICIAL INTELLIGENCE. U4U DISCLAIMS ALL WARRANTIES RELATED TO THE TRANSLATIONS, EXPRESS OR IMPLIED, INCLUDING ANY WARRANTIES OF ACCURACY, RELIABILITY, AND ANY IMPLIED WARRANTIES FOR FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT.</p>



<h2 >06 REGISTRATION AND ELIGIBILITY</h2>

<p>6.1. To use the App, you may be required to create or update an account ("Account") and will be asked to provide certain personal information, which may include your name, birth date, and email address.</p>

<p>6.2. All information provided during Account creation must be accurate. You will update that information promptly after it changes.</p>

<p>6.3. This information will be held and used in accordance with our <a href="https://www.termsfeed.com/live/32a5fb9a-77ce-4c64-89c4-35c77b1d40b0" target="_blank" rel="noreferrer noopener" >Privacy Policy</a>, which can be found at <a data-auto-recognition="true" href="http://www.u4uteen.com" target="_blank" >www.u4uteen.com</a> ("Privacy Policy").</p>

<p>6.4. U4U reserves the right to deny admission to a House, in its sole discretion.</p>



<h2 >07 YOUR USE OF THE U4U APP</h2>

<p>7.1. Any content you submit through the App is governed by the Company's Privacy Policy. If you submit a question or response, you are solely responsible for your own communications, the consequences of posting those communications, and your reliance on any communications found in public areas or Houses. The Company and its licensors are not responsible for the consequences of any communications in Houses or public areas. In cases where you feel threatened or you believe someone else is in danger, you should contact your local law enforcement agency immediately. If you think you may have a medical emergency, call your doctor or emergency services immediately (911 or 988 Suicide &amp; Crisis Lifeline). As a condition of using the App, you agree not to use the App for any purpose that is prohibited by this Agreement. You are responsible for all of your activity in connection with the App and you shall abide by all local, state, national, and international laws and regulations and any applicable regulatory codes.</p>

<p>7.2. You agree that if you take any of the following actions, you will be materially breaching this Agreement, and you agree that you SHALL NOT:</p>

<p>7.2.1. resell, rent, lease, loan, sublicense, distribute, or otherwise transfer rights to the App;</p>

<p>7.2.2. modify, reverse engineer, decompile or disassemble the App;</p>

<p>7.2.3. copy, adapt, alter, modify, translate, or create derivative works of the App without the written authorization of the Company;</p>

<p>7.2.4. permit other individuals to use the App, including but not limited to shared use via a network connection, except under the terms of this Agreement;</p>

<p>7.2.5. circumvent or disable any technological features or measures in the App for protection of intellectual property rights;</p>

<p>7.2.6. use the App in an attempt to, or in conjunction with, any device, program, or service designed to circumvent technological measures employed to control access to, or the rights in, a content file or other work protected by the copyright laws of any jurisdiction;</p>

<p>7.2.7. use or access the App to compile data in a manner that is used or usable by a competitive product or service;</p>

<p>7.2.8. use your Account to advertise, solicit, or transmit any commercial advertisements, including chain letters, junk e-mail or repetitive messages to anyone;</p>

<p>7.2.9. use your Account to engage in any illegal conduct;</p>

<p>7.2.10. upload or transmit any communications that infringe or violate the rights of any party;</p>

<p>7.2.11. upload media of any kind that contain expressions of hate, abuse, offensive images or conduct, obscenity, pornography, sexually explicit or any material that could give rise to any civil or criminal liability under applicable law or regulations or that otherwise may be in conflict with this Agreement, and the Company's <a href="https://www.termsfeed.com/live/32a5fb9a-77ce-4c64-89c4-35c77b1d40b0" target="_blank" rel="noreferrer noopener" >Privacy Policy</a>;</p>

<p>7.2.12. upload any material that contains software viruses or any other computer code, files or programs that is malicious, technologically harmful or designed to interrupt, destroy or limit the functionality of any computer software, website or the App;</p>

<p>7.2.13. use any features or content from the App to diagnose, treat, or mitigate any health conditions or as a substitute for professional medical or mental health care.</p>

<p>7.2.14. share, screenshot, or distribute private information or content from U4U Houses outside of your House without explicit permission from all affected users;</p>

<p>7.2.15. impersonate another user, House Lead, or U4U staff member;</p>

<p>7.2.16. attempt to access another user's account or private information;</p>

<p>7.2.17. harass, bully, threaten, or abuse other users, House Leads, or U4U staff;</p>

<p>7.2.18. share child sexual abuse material (CSAM) or content depicting minors in sexual situations;</p>

<p>7.2.19. promote, encourage, or glorify self-harm, suicide, or disordered eating;</p>

<p>7.2.20. engage in hate speech or discriminatory behavior based on race, ethnicity, religion, sexual orientation, gender identity, disability, or other protected characteristics.</p>

<p>Any such forbidden use shall immediately terminate your license to use the App. U4U is granting you permission to use the App, but with the condition that you use it in accordance with the Agreement. If you violate these Terms by engaging in a forbidden use, the permission granted you to use the App will be revoked, and you will no longer be authorized to use it.</p>



<h2 >08 EXPORT AND ECONOMIC SANCTIONS CONTROL</h2>

<p>8.1. The software that supports the App may be subject to export and re-export control laws and regulations, including the Export Administration Regulations ("EAR") maintained by the U.S. Department of Commerce, trade and economic sanctions maintained by the Treasury Department's Office of Foreign Assets Control ("OFAC"), and the International Traffic in Arms Regulations ("ITAR") maintained by the Department of State.</p>

<p>8.2. You represent and warrant that you are (1) not located in any country or region that is subject to government embargo, and (2) are not a denied party as specified in the regulations listed above.</p>

<p>8.3. You agree to comply with all export laws and regulations to ensure that neither the App nor any technical data related thereto nor any direct product or products derived from or based on such technology received from U4U under these Terms of Use thereof is exported or re-exported directly or indirectly in violation of, or used for any purposes prohibited by, such laws and regulations.</p>



<h2 >09 LIMITED LICENSE TO THE APP</h2>

<p>9.1. We grant you a personal, worldwide, revocable, non-transferable and non-exclusive license to access and use the App for personal and non-commercial purposes in accordance with the terms of this Agreement. You may not copy, store, modify, distribute, transmit, perform, reproduce, publish, license, create derivative works from, transfer or sell any text, graphics, logos and other source-identifying symbols, designs, icons, images, or other information, software or code obtained from the App without prior express written permission from the Company which may be withheld for any or no reason. You further agree not to download, display or use any content on the App that is provided by the Company or its licensors located on the App for use in any publications, in public performances, on websites other than the App for any other commercial purpose, in connection with products or services that are not those of the Company, in any other manner that is likely to cause confusion among consumers, that disparages or discredits the Company and/or its licensors, that dilutes the strength of the Company or its licensor's property, or that otherwise infringes the Company or its licensors' intellectual property rights. You further agree to in no other way misuse any content published by the Company or third-party content that appears on the App.</p>

<p>9.2. All rights, title, and interest in and to the App not expressly granted in this Agreement are reserved by the Company. If you wish to use the Company's software, title, trade name, trademark, service mark, logo, domain name and/or any other identification with notable brand features or other content owned by the Company, you must obtain written permission from the Company. Permission requests may be sent to <a data-auto-recognition="true" href="mailto:team@u4uteen.com" >team@u4uteen.com</a>.</p>

<p>9.3. To avoid any doubt, the Company owns all the text, images, photos, audio, video, location data, software, code, and all other forms of data or communication that the Company creates and makes available in connection with the App, including but not limited to visual interfaces, interactive features, graphics, design, compilation of User Content (as defined below), and the compilation of aggregate user review ratings and all other elements and components of the App, excluding User Content (collectively referred to herein as the "Company's Content"). Except as expressly and unambiguously provided herein, we do not grant you any express or implied rights, and all rights in and to the App and the Company's Content are retained by us.</p>



<h2 >10 LICENSE TO USER CONTENT</h2>

<p>10.1. The App enables you to input personal notes, share your stories, post or upload content, and log certain information into the App ("User Content"). You retain all rights to such User Content that you post, share, or log in the App.</p>

<p>By providing your User Content to the App, you (a) grant the Company a non-exclusive, transferable, sublicensable, worldwide, royalty-free license to use, copy, exploit, modify, publicly display, publicly perform, create derivative works from, incorporate it into other works, change, reformat, and distribute your User Content in connection with providing and operating the App and related services and/or for the Company's promotional purposes (for example, by displaying on our website, within the App, in social media, on any website or platform in the internet as we may deem appropriate), subject to the <a href="https://www.termsfeed.com/live/32a5fb9a-77ce-4c64-89c4-35c77b1d40b0" target="_blank" rel="noreferrer noopener" >Privacy Policy</a>; and (b) you agree to indemnify the Company and its affiliates, directors, officers, and employees and hold them harmless from any and all claims and expenses, including attorneys' fees, arising from the User Content and/or your failure to comply with the terms described in this Agreement.</p>

<p>10.2. The Company reserves the right to review all User Content prior to submission to the App and to remove any content or media for any reason, at any time, without prior notice, at our sole discretion.</p>



<h2 >11 USE AT YOUR OWN RISK</h2>

<p>11.1. Our goal is to help make certain health-related information more readily available and useful to you. However, the App cannot and does not guarantee health-related improvements or outcomes.</p>

<p>11.2. Your use of the App and any information, predictions, or suggestions provided in the App are at your sole risk. We make no representation or warranty of any kind as to the accuracy of data, information, estimates, and predictions that we may provide to you through the App and you agree and understand that the App is not intended to match or serve the same purpose as a medical or scientific device or healthcare provider.</p>



<h2 >12 USE BY MINORS DISCLAIMER</h2>

<p>12.1. THE INFORMATION WITHIN THE APP DOES NOT INCITE, INDUCE OR OTHERWISE PROMOTE ANY SEXUAL BEHAVIOR OR ACTIVITY AMONG MINORS AND DOES NOT DIRECT THE CONTENT OF COMMUNICATION TO ANY PARTICULAR PERSON. ALL INFORMATION PROVIDED WITHIN THE APP IS FOR GENERAL EDUCATIONAL PURPOSES ONLY.</p>

<p>12.2. We carefully examine the materials that we make available via the App to people between 11 and 17 in order to avoid any inappropriate or harmful content. We fully understand that moral and ethical rules might differ from country to country in defining what information related to sexuality is accessible to minors.</p>

<p>12.3. We neither intend nor knowingly publish sexually explicit content, or content that otherwise might qualify as harmful to minors or juveniles under applicable law. We make reasonable efforts to ensure that all materials provided by us on the App are based on facts only and are scientifically accurate.</p>

<p>Please be aware that individual ethical views on what is offensive or harmful to minors may vary from the requirements set for content that may be made available to minors under applicable law.</p>



<h2 >13 SUBSCRIPTIONS AND BILLING</h2>

<p>13.1. Subscriptions. We may offer you the opportunity to purchase subscriptions that provide access to certain content, products or services for a specified period of time. Subscriptions continue indefinitely. We charge you on-going fees automatically on a regular basis until canceled. We explain the on-going fees, the billing frequency and how to cancel before you purchase.</p>

<p>13.2. Certain content, products or services included in subscription may change from time to time, as we introduce new features, develop our existing offering and sometimes retire features that aren't working out as planned. The features and content contained in the App may differ by country, language, relevant store, version or device.</p>

<p>By accessing the App you agree that your purchases are not contingent on the provision of any future functionality or features, or dependent on any oral or written public statements, and comments made by U4U regarding such functionality or features.</p>

<p>13.3. The App is available via the third-party platform operator Apple App Store. Therefore, when you make a purchase, you may additionally enter into a separate contract with the respective third-party service provider providing your app store, whose terms and conditions may apply. Depending on the respective third-party service provider's terms and conditions, you may need to exercise your rights of cancellation and revocation with these service providers.</p>

<p>13.4. Billing. You may purchase the parent subscription on a recurring basis disclosed to you prior to your purchase directly from U4U or through a third party by paying a subscription fee plus applicable taxes in advance.</p>

<p>13.5. Trial. Some of our parent subscriptions may include a trial period, where you can experience the application for a specified period at no cost or at a reduced price ("Trial"). Trials will automatically convert into ongoing paid subscriptions at the end of the trial period. To avoid being charged, you must cancel your subscription prior to the expiration of the trial period. Please review all applicable terms carefully before you sign up for Trial.</p>

<p>13.6. Price and tax changes. U4U may from time to time make changes to parent subscription, including recurring subscription fees and will communicate any price changes to you in advance. Price changes will take effect at the start of the next subscription period following the date of the price change and, by continuing to use the subscription after the price change takes effect, you will have accepted the new price. If you don't agree to a price change, you can reject the change by unsubscribing from the applicable subscription prior to the price change going into effect.</p>

<p>If we discover an error in the price of items you have purchased, we will contact you. You will have the option of either reconfirming your order at the correct price or canceling it. If we are unable to contact you, your purchase will be automatically canceled.</p>

<p>Tax rates or other fees are based on the rates applicable at the time of your monthly charge. These amounts can change over time with local tax requirements in your country, state, territory, county, or city. Any change in tax rate will be automatically applied based on the account information you provide.</p>

<p>13.7. Renewal. Your payment to U4U or the third party through which you purchased the parent subscription will automatically renew at the end of the applicable subscription period, unless you cancel your subscription before the end of the then-current subscription period.</p>

<p>13.8. Cancellation. You must cancel your parent subscription or Trial before it renews to avoid the billing of the fees for the next Subscription period. If you purchase your subscription through the App, you can cancel the renewal of your subscription at any time by contacting us by email at <a data-auto-recognition="true" href="mailto:team@u4uteen.com" >team@u4uteen.com</a> and specify the email you used to register your account on the app.</p>

<p>13.9. Promotional offers. From time to time you may have the opportunity to purchase a parent subscription in the form of Promotional offer. Promotional offers may be for new users only and/or not be valid for all users and are only available for a limited time. Other restrictions may apply. After the promotional period, subscription automatically continues at the then-current regular price (subject to change), unless canceled, plus applicable taxes.</p>



<h2 >14 U4U HOUSES</h2>

<p>14.1. What are U4U Houses?</p>

<p>4U Houses are small communities of girls in the same grade who 1. share a feed that shows their responses to growth and wellness activities, 2. Share a messaging channel moderated by a U4U house lead to communicate with each other, 3. Can be matched with a sister in the same house for moderated messaging and activities to inspire each other to grow in their ability to communicate effectively, 4. Aggregate points to compete against other houses for prize points.&nbsp;</p>

<p>Each House has a trained House Lead who facilitates activities, moderates and ensures a safe, supportive environment.</p>

<p>14.2. House Rules and Member Conduct</p>

<p>As a member in a U4U House, you shall not:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Leave rude, harassing, insulting, provocative, discriminating, non-tolerant, religious, racist, political, homophobic, libelous, defamatory, unlawful, threatening, or offensive comments and statements;</li>
<li>Post abusive, offensive, obscene, pornographic, infringing, sexually explicit images or any other materials (including links to such materials) prohibited under applicable law or regulations or that otherwise may be in conflict with this Agreement;</li>
<li>Provide any medical advice or claim to be a healthcare professional;</li>
<li>Advertise any product or service;</li>
<li>Screenshot or share private House content outside your House;</li>
<li>Share personal contact information (phone numbers, addresses, social media accounts) within Houses;</li>
<li>Engage in any behavior that violates our Community Guidelines.</li>
</ul>

<p>14.3. U4U's Rights and Moderation</p>

<p>At our sole discretion, we reserve our right to:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Delete any inappropriate or irrelevant comments or materials;</li>
<li>Delete or modify comments containing personal data, such as name, address, or email;</li>
<li>Restrict or ban your access to U4U Houses at any time and without notice if we determine that the content or use of Houses is in violation of this Agreement;</li>
<li>Use, copy, modify, reshuffle, move, change, publicly display, publicly conduct and distribute discussions, comments, and materials (subject to our Privacy Policy);</li>
<li>Block your comments for any reasons or moderate them as we deem appropriate.</li>
</ul>

<p>14.4. Disclaimer Regarding House Content</p>

<p>Any information posted in Houses shall not be considered as advice, drug prescription, or treatment suggestion. If in doubt about your health, consult a licensed healthcare professional. Please bear in mind that our users are not healthcare professionals and their recommendations may not only be inaccurate, but also harmful to your health and well-being.</p>

<p>TO THE MAXIMUM EXTENT PERMITTED UNDER APPLICABLE LAW (INCLUDING, BUT NOT LIMITED TO, THE COMMUNICATIONS DECENCY ACT OF 1996, DIRECTIVE ON ELECTRONIC COMMERCE 2000/31/EC), THE COMPANY DISCLAIMS LIABILITY FOR ANY DIRECT OR INDIRECT CONSEQUENCES ARISING FROM THE INFORMATION, LINKS, AND MATERIALS POSTED BY USERS, ANY ACTIONS OR INACTIONS OF USERS, VIOLATIONS OF ANY APPLICABLE LAWS AND REGULATIONS.</p>



<h2 >15 HOUSE LEADS: ROLES, LIMITATIONS, AND ACCESS TO USER INFORMATION</h2>

<p>15.1. What is a House Lead?</p>

<p>A House Lead is a trained facilitator (typically a college student ages 18-25) assigned to each U4U House to guide activities, foster positive community, and ensure safety.</p>

<p>15.2. House Leads ARE:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Trained in facilitation, safety protocols, and community building</li>
<li>Screened through background checks and interviews</li>
<li>Required to complete ongoing training</li>
<li>Available to support House activities and respond to safety concerns</li>
<li>Able to see all content posted within their assigned House, including messages, photos, and activity completions</li>
</ul>

<p>15.3. House Leads ARE NOT:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Licensed therapists, counselors, psychologists, psychiatrists, social workers, or medical professionals</li>
<li>Available 24/7 (they have designated response times and schedules)</li>
<li>Providing clinical mental health services or treatment</li>
<li>Qualified to provide crisis intervention or emergency mental health support</li>
<li>Personal friends or peers (they maintain professional boundaries)</li>
</ul>

<p>15.4. House Lead Access to Your Information</p>

<p>House Leads CAN see within their assigned House:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>All messages posted in the House</li>
<li>Activity completions and responses</li>
<li>Photos and content shared</li>
<li>User profiles and basic account information</li>
</ul>

<p>House Leads CANNOT see:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Content from other Houses to which they are not assigned</li>
<li>Detailed parent dashboard information</li>
<li>Account payment information</li>
</ul>

<p>15.5. House Lead Training and Responsibilities</p>

<p>House Leads are trained to:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Create a welcoming, inclusive House environment</li>
<li>Facilitate wellness activities and discussions</li>
<li>Enforce Community Guidelines and these Terms</li>
<li>Recognize signs of distress or concerning content</li>
<li>Report safety concerns to U4U staff immediately</li>
<li>Direct users to appropriate professional resources when needed</li>
<li>Maintain appropriate boundaries with House members</li>
</ul>

<p>15.6. What House Leads Will Do</p>

<p>If a House Lead sees concerning content or behavior, they will:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Reach out to the user privately with support and resources</li>
<li>Escalate serious concerns to U4U staff immediately</li>
<li>Contact parents/guardians when safety is at risk</li>
<li>Report to authorities when required by mandatory reporting laws</li>
<li>Remove content that violates Community Guidelines</li>
<li>Recommend professional resources (therapist, doctor, etc.) when appropriate</li>
</ul>

<p>15.7. Limitations on House Lead Support</p>

<p>House Leads operate during specified hours and may not respond immediately. Response time expectations are typically within 24 hours during active periods, but this is not guaranteed.</p>

<p>If you need immediate support:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Call 911 (emergencies)</li>
<li>Call or text 988 (Suicide &amp; Crisis Lifeline)</li>
<li>Text "HELLO" to 741741 (Crisis Text Line)</li>
<li>Contact your therapist, doctor, or trusted adult</li>
</ul>

<p>DO NOT rely on House Leads for crisis intervention or emergency support.</p>



<h2 >16 CRISIS PROTOCOL AND EMERGENCY RESOURCES</h2>

<p>16.1. U4U is NOT a Crisis Service</p>

<p>U4U provides peer support, wellness activities, and community connection. U4U does NOT provide crisis intervention, emergency mental health services, or medical care.</p>

<p>16.2. If You Are in Crisis</p>

<p>If you or someone you know is experiencing any of the following, DO NOT post in U4U Houses or wait for a House Lead response. Get help immediately:</p>



<p>IMMEDIATE EMERGENCIES:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Suicidal thoughts or plans</li>
<li>Self-harm urges or behavior</li>
<li>Thoughts of harming others</li>
<li>Sexual assault or abuse (current or recent)</li>
<li>Physical abuse or violence</li>
<li>Any situation where someone is in immediate danger</li>
</ul>



<p>CALL IMMEDIATELY:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>911 - For any emergency requiring immediate assistance</li>
<li>988 - Suicide &amp; Crisis Lifeline (call or text, available 24/7, free, confidential)</li>
<li>Crisis Text Line - Text "HELLO" to 741741 (24/7, free, confidential)</li>
</ul>



<p>OTHER CRISIS RESOURCES:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>National Sexual Assault Hotline: 1-800-656-HOPE (4673)</li>
<li>National Domestic Violence Hotline: 1-800-799-7233</li>
<li>Childhelp National Child Abuse Hotline: 1-800-422-4453</li>
<li>Trevor Project (LGBTQ Youth): 1-866-488-7386 or text START to 678-678</li>
<li>Trans Lifeline: 1-877-565-8860</li>
</ul>



<p>16.3. Non-Emergency Support</p>

<p>For situations that are serious but not emergencies (such as ongoing depression, anxiety, family conflict, or other mental health concerns), we strongly encourage you to:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Talk to your parents or trusted adult</li>
<li>Contact your school counselor</li>
<li>See a licensed therapist or mental health professional</li>
<li>Call your doctor</li>
</ul>

<p>House Leads can provide support and encouragement, but they cannot replace professional mental health care.</p>

<p>16.4. Your Responsibilities</p>

<p>By using U4U, you understand and agree that:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>U4U is not a substitute for professional mental health care</li>
<li>You will not rely on U4U Houses or House Leads for crisis intervention</li>
<li>You will seek appropriate professional help when needed</li>
<li>You will call emergency services if you or someone else is in danger</li>
<li>You will not share graphic details of self-harm, suicide plans, or methods in Houses (this can be harmful to other users)</li>
</ul>



<h2 >17 MANDATORY REPORTING OBLIGATIONS</h2>

<p>17.1. Legal Obligation to Report</p>

<p>House Leads and certain U4U staff members MAY be mandatory reporters under state law. This means they may be LEGALLY REQUIRED to report certain situations to authorities, even if you ask them not to. We reserve the right to report concerning activity to appropriate authorities.</p>

<p>You will never be banned or punished for disclosing abuse, assault, or harm. We may need to take safety steps (like contacting parents or authorities), but you will not lose access to U4U for seeking help or sharing your experiences.</p>

<p>17.2. You Will Usually Be Informed</p>

<p>In most cases, we will inform you and your parents/guardians that a report has been made. However, there may be circumstances where:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Authorities direct us not to inform you immediately</li>
<li>Informing parents would place you at greater risk</li>
<li>Law enforcement requests we not disclose the report</li>
</ul>

<p>17.3. Mandatory Reporting may be a Legal Requirement</p>

<p>By using U4U, users understand and acknowledge that:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>House Leads and staff cannot promise confidentiality when mandatory reporting obligations apply</li>
<li>Reporting may be required by law and may not be optional</li>
<li>Reports are made to protect user safety and the safety of others</li>
</ul>

<p>17.6. This Does Not Apply to Everything You Share</p>

<p>Most conversations in Houses are private and confidential. Mandatory reporting only applies to specific situations involving suspected abuse, neglect, or imminent harm. General discussions about stress, everyday challenges, friendship issues, school problems, and similar topics do NOT trigger mandatory reporting obligations.</p>

<p>17.7. Questions About Mandatory Reporting</p>

<p>If you have questions about what is or is not subject to mandatory reporting, you may:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Speak with your parent or guardian</li>
<li>Ask your House Lead before sharing</li>
<li>Contact U4U Support at <a href="mailto:team@u4uteen.com" target="_self" >team@u4uteen.com</a></li>
<li>Consult with a trusted adult</li>
</ul>
        

<h2>18 PRIVACY IN U4U HOUSES AND SCREENSHOT LIMITATIONS</h2>

<p>18.1. Houses Are Private Spaces</p>

<p>Your U4U House is a private space shared with your housemates and your House Lead. Content posted in Houses is not visible to:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Users in other Houses</li>
<li>Your parents (unless you're under 13, in which case parents have rights to access - see Section 19)</li>
<li>The general public</li>
<li>Other U4U staff (except as a standard part of technical review and when reviewing reported content or safety concerns)</li>
</ul>

<p>18.2. Privacy Rules</p>

<p>All House members agree to:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Keep House conversations confidential</li>
<li>NOT screenshot or share House content outside the House</li>
<li>NOT share other users' personal information outside the House</li>
<li>Respect the privacy of all House members</li>
<li>Think carefully before sharing sensitive information</li>
</ul>

<p>18.3. Important Privacy Limitations</p>

<p>While we prohibit screenshots and sharing of House content, you must understand these critical limitations:</p>

<p>WE CANNOT TECHNOLOGICALLY PREVENT SCREENSHOTS. Most mobile devices allow users to take screenshots, and U4U cannot disable this functionality.</p>

<p>WE CANNOT CONTROL WHAT USERS DO WITH INFORMATION AFTER IT'S SHARED. Once you share something in your House, other House members could:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Take screenshots (despite our rules against it)</li>
<li>Remember and repeat what you said</li>
<li>Share information outside the House (despite our prohibition)</li>
</ul>

<p>WE CANNOT GUARANTEE ABSOLUTE PRIVACY. While we enforce strict privacy rules and will terminate accounts of users who violate them, we cannot undo information that has already been shared.</p>

<p>18.4. What You Should Do</p>

<p>Before sharing anything in your House, ask yourself:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Would I be okay if this information went beyond my House?</li>
<li>Am I sharing someone else's private information? If yes, donâ€™t share it.</li>
<li>Could this harm me or someone else if it was shared more widely? If yes, donâ€™t share it.</li>
<li>Is this something I'm comfortable with my House Lead seeing?</li>
</ul>

<p>Based on those questions, only share what you're comfortable with others potentially knowing.</p>

<p>18.5. Consequences for Privacy Violations</p>

<p>Users who screenshot or share House content outside their House will face:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>First offense: Warning and education about privacy</li>
<li>Second offense: Temporary account suspension (7-30 days)</li>
<li>Third offense or serious violations: Permanent account termination</li>
</ul>

<p>However, we acknowledge that even with termination, we cannot undo information that was already shared.</p>

<p>18.6. Who Can See House Content</p>

<p>Within your House:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>All House members can see all activity response content posted</li>
<li>Your House Lead can see all content posted</li>
<li>Only people in your house can see messages sent in the house group chat. Other houses can not see these messages.</li>
<li>Only you can see your daily mood and sleep checkins. These are not shared with your house, nor your house lead, nor any other house.</li>
<li>U4U staff can see content if it's reported or flagged for review</li>
</ul>

<p>Outside your House:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Parents of users under 13 can request access to their child's House content</li>
<li>Law enforcement can request access with valid legal process</li>
<li>We may access content if required by law or to investigate safety concerns</li>
</ul>

<p>18.7. Your Consent</p>

<p>By using U4U Houses, you understand and consent to:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Sharing your House content with your housemates and House Lead</li>
<li>The privacy limitations described above</li>
<li>The risk that other users may violate privacy rules</li>
<li>The fact that we cannot guarantee absolute privacy</li>
</ul>

<h2>19 PARENT SUBSCRIBERS AND ACCESS</h2>

<p>19.1. Parent Subscription Option</p>

<p>U4U offers an optional parent subscription tier that provides parents with access to a Parent Membership.</p>

<p>19.2. Different Rights for Different Ages</p>

<p>For Users Under 13:</p>

<p>A verified parent or legal guardian may request access to the personal information collected from their child and maintained by U4U under COPPA, including:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Account information and settings</li>
<li>Messages or content stored within the account</li>  
<li>Mood, sleep, or activity data retained in the system</li>
<li>Photos or other content shared and stored by U4U</li>
</ul>

<p>Information that is not retained, has been deleted, or cannot reasonably be retrieved may not be available.</p>

<p>Access may be provided in a format that protects system integrity, other usersâ€™ privacy, and the childâ€™s safety.</p>

<p>For Users Ages 13-17:</p>

<p>Parents who subscribe to the Parent Membership tier may have unique access.&nbsp;</p>

<p>PARENTS MAY HAVE ACCESS TO:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Activity engagement (e.g., "completed 5 activities this week")</li>
<li>Login frequency and general usage patterns</li>
<li>Content categories explored (e.g., "culture," "stress environment")</li>
</ul>

<p>PARENTS CANNOT SEE (VIA THE MEMBERSHIP):</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Specific messages sent in Houses</li>
<li>Detailed responses to individual activities</li>
<li>Private communications with House Leads</li>
<li>Content shared by other House members</li>
<li>Exact wording of mood check-ins</li>
</ul>

<p>19.3. Why This Approach?</p>

<p>We designed the Parent Membership to:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Give parents meaningful oversight without eliminating teen privacy</li>
<li>Encourage teens to use U4U honestly (knowing parents won't read every word)</li>
</ul>

<p>Research shows that teens are more likely to seek help and share honestly when they have some privacy, while parents still need to monitor their child's overall wellbeing.</p>

<p>19.4. When Parents May Get Additional Access<br />
<br />
U4U prioritizes teen safety. In rare situations involving serious risk of harm, U4U may take appropriate action in accordance with applicable law and professional standards.</p>

<p>Note: U4U is not a medical or mental health provider and does not diagnose. Any access provided is intended to support teen safety and connect families to qualified professionals when needed.</p>

<p>19.5. Parent Respect of Teen Accounts</p>

<p>Parents agree that they will NOT:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Impersonate their teen on U4U</li>
<li>Post or send messages as their teen</li>
<li>Interfere with their teen's House participation</li>
<li>Share their teen's private U4U information with others without good reason</li>
</ul>

<p>Parents who violate these terms may have their Parent Membership access revoked.</p>

<p>19.6. Teen Users Should Know</p>

<p>If you are 13-17 and your parent subscribes to the Parent Membership:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Your parent will see general trends, not specific content</li>
<li>You should still use U4U honestly - it's designed to support you</li>
<li>Your House Lead will not report routine conversations to your parents</li>
<li>Serious safety concerns may be shared with parents (see Sections 16-17)</li>
<li>You can discuss the Parent Membership with your House Lead if you have concerns</li>
</ul>

<p>19.7. For Users 18+</p>

<p>U4U is designed for ages 11-18. Users older than 18 should not create accounts. If you turn 18 while using U4U, you may continue using the platform until you graduate from high school or age 19, whichever comes first. Parent Membership access ends when you turn 18.</p>



<h2>20 PASSWORDS</h2>

<p>20.1. You are responsible for taking all reasonable steps to ensure that no unauthorized person shall have access to your U4U passwords or account. It is your sole responsibility to (1) control the dissemination and use of sign-in name, screen name and passwords; (2) authorize, monitor, and control access to and use of your U4U account and password; (3) promptly inform the Company if you believe your account or password has been compromised or if there is any other reason you need to deactivate a password by sending an email to <a data-auto-recognition="true" href="mailto:team@u4uteen.com" >team@u4uteen.com</a>.</p>

<p>20.2. You grant the Company and all other persons or entities involved in the operation of the App the right to transmit, monitor, retrieve, store, and use your information in connection with the operation of the App. You further acknowledge and agree that the App and account are designed and intended for personal use on an individual basis and you should not share your account and/or password details with another individual. The Company cannot and does not assume any responsibility or liability for any information you submit, or your or third parties' use or misuse of information transmitted or received arising from the using the App, and shall not be responsible for any losses arising out of the unauthorized use of your account or information resulting from you not following these rules.</p>



<h2>21 WARRANTY DISCLAIMER</h2>

<p>21.1. The Company controls and operates the App from various locations and makes no representation that the App is appropriate or available for use in all locations. The App or certain features of it may not be available in your location or may vary across locations.</p>

<p>21.2. THE APP IS PROVIDED "AS IS", "AS AVAILABLE" AND IS PROVIDED WITHOUT ANY REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF TITLE, NON-INFRINGEMENT, MERCHANTABILITY, AND FITNESS FOR A PARTICULAR PURPOSE, AND ANY WARRANTIES IMPLIED BY ANY COURSE OF PERFORMANCE OR USAGE OF TRADE, ALL OF WHICH ARE EXPRESSLY DISCLAIMED, SAVE TO THE EXTENT REQUIRED BY LAW.</p>

<p>NEITHER THE COMPANY, NOR ANY OF ITS OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, AFFILIATES, REPRESENTATIVES, SUPPLIERS, PARTNERS, ADVERTISERS OR CONTENT PROVIDERS WARRANTS, AND EACH OF THEM HEREBY EXPRESSLY DISCLAIMS, THAT: (A) THE APP WILL BE SECURE OR AVAILABLE AT ANY PARTICULAR TIME OR LOCATION; (B) ANY DEFECTS OR ERRORS WILL BE CORRECTED; (C) ANY CONTENT OR SOFTWARE AVAILABLE AT OR THROUGH THE APP IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS; (D) THE RESULTS OF USING THE APP WILL MEET YOUR REQUIREMENTS; OR (E) THE ACCURACY, RELIABILITY, OR COMPLETENESS OF THE CONTENT, TEXT, IMAGES, SOFTWARE, GRAPHICS, OR COMMUNICATIONS PROVIDED BY THIRD PARTIES ON OR THROUGH THE APP.</p>

<p>YOUR USE OF THE APP IS SOLELY AT YOUR OWN RISK. SOME STATES, COUNTRIES DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES, SO SOME OR ALL OF THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU.</p>



<h2>22 LIMITATION OF LIABILITY</h2>

<p>22.1. IN NO EVENT SHALL THE COMPANY OR ANY OF ITS OFFICERS, DIRECTORS, AGENTS, AFFILIATES, EMPLOYEES, REPRESENTATIVES, SUPPLIERS, PARTNERS, ADVERTISERS, OR DATA PROVIDERS BE LIABLE FOR ANY INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, EXEMPLARY OR PUNITIVE DAMAGES (INCLUDING BUT NOT LIMITED TO LOSS OF USE, LOSS OF PROFITS, OR LOSS OF DATA) WHETHER IN AN ACTION IN CONTRACT, TORT (INCLUDING BUT NOT LIMITED TO NEGLIGENCE), EQUITY OR OTHERWISE, ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OR MISUSE OF THIS APP.</p>

<p>IN NO EVENT WILL THE COMPANY'S TOTAL LIABILITY ARISING OUT OF OR IN CONNECTION WITH THESE TERMS OR FROM THE USE OF OR INABILITY TO USE THE APP EXCEED THE AMOUNTS YOU HAVE PAID TO THE COMPANY FOR USE OF THE APP OR ONE HUNDRED DOLLARS ($100) IF YOU HAVE NOT HAD ANY PAYMENT OBLIGATIONS TO THE COMPANY, AS APPLICABLE.</p>

<p>SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY, SO THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU. NONE OF THE COMPANY OR ANY OF ITS OFFICERS, DIRECTORS, AGENTS, AFFILIATES, EMPLOYEES, REPRESENTATIVES, SUPPLIERS, PARTNERS, ADVERTISERS, OR CONTENT PROVIDERS, OR ANY THIRD PARTIES MENTIONED ON THE APP SHALL BE LIABLE FOR ANY PERSONAL INJURY, INCLUDING DEATH, CAUSED BY YOUR USE OR MISUSE OF THE APP.</p>

<p>THE LAWS OF SOME STATES / COUNTRIES IMPOSE RESTRICTIONS ON LIMITING LIABILITY. NOTHING IN THIS AGREEMENT EXCLUDES OR LIMITS OUR LIABILITY TO YOU WHERE IT WOULD BE UNLAWFUL TO DO SO. WHERE ANY PROVISION IS EXPRESSED TO EXCLUDE OR LIMIT LIABILITY TO A GREATER EXTENT THAN PERMITTED BY APPLICABLE LAW, THAT PROVISION SHALL BE DEEMED TO ONLY EXCLUDE OR LIMIT OUR LIABILITY TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW.</p>



<h2>23 USE OF MOBILE DEVICES</h2>

<p >23.1. Please note that your carrier's normal rates and fees, such as text messaging and data charges, will still apply if you are using the App on a mobile device.</p>



<h2>24 THIRD-PARTY SERVICES AND LINKS</h2>

<p>24.1. The App may give you access to links to third-party websites, apps, or other products or services ("Third Party Services"). The Company does not control Third Party Services in any manner and, accordingly, the Company is not responsible for the privacy practices of such Third Party Services and does not assume any liability associated with such Third Party Services. Your linking to or use of any Third Party Services other than the App is at your own risk. The Company's inclusion of links to Third Party Services does not imply any endorsement of any kind by the Company of the material located on or linked to by such Third Party Services and should not be deemed as such by any user of the App. The Company disclaims any responsibility for the products or services offered or the information contained on any Third Party Services.</p>

<p>You need to take appropriate steps to determine whether accessing a Third Party Service is appropriate, including protecting your personal information and privacy in using any such Third Party Services and complying with relevant agreements.</p>

<p>You shall not link to our websites, app, content or services in a way that is: (i) illegal, (ii) suggests any form of association, approval or endorsement with or by us where none exists, (iii) damages our reputation or takes advantage of it, or (iv) is unfair.</p>



<h2>25 YOUR FEEDBACK</h2>

<p >25.1. We welcome your feedback about the App. Unless otherwise expressly declared, any communications you send to us or publish in app stores are deemed to be submitted on a non-confidential basis. You agree that we may decide to publicize such contents at our own discretion. You agree to authorize us to make use of such contents for free, and revise, modify, adjust and change it contextually, or make any other changes, in each case as we deem appropriate.</p>



<h2>26 ENFORCEMENT RIGHTS</h2>

<p>26.1. We are not obligated to monitor access or use of the App. However, we reserve the right to do so for purposes of operating and maintaining the App, ensuring your compliance with this Agreement, and complying with applicable legal requirements. We may disclose unlawful conduct to law enforcement authorities, and pursuant to valid legal process, we may cooperate with law enforcement authorities to prosecute users who violate the law.</p>

<p>26.2. We reserve the right (but are not required) to remove or disable any content posted to the App or access to the App at any time, in each case without notice and at our sole discretion if we determine in our sole discretion that your content or use of the App is objectionable or in violation this Agreement.</p>

<p>We may refuse service, close Accounts, and change eligibility requirements at any time.</p>

<p>The Company has no liability or responsibility to users of the App or any other person or entity for performance or nonperformance of the aforementioned activities.</p>



<h2>27 MAINTENANCE AND UPDATES</h2>

<p>27.1. From time to time, it may become necessary to change, expand, upgrade and improve the App to ensure it is functioning properly. We may also, at any time, cease to continue operating part or all of the App or selectively disable certain features of the App. Your use of the App does not entitle you to the continued provision or availability of the App.</p>

<p>27.2. Any modification or elimination of the App or any particular features will be done in our sole and absolute discretion and without an ongoing obligation or liability to you.</p>

<p>27.3. We may indefinitely suspend, or discontinue online access to content associated with U4UTeen at any time, including for service deprecations, maintenance services, or upgrades, without prior notice or liability. We may also discontinue offering certain content or features. For any content or features that use online servers, we make no commitment to continue to make those servers available.</p>



<h2>28 INDEMNITY</h2>

<p >28.1. You agree to defend, indemnify, and hold the Company, its officers, directors, employees, agents, affiliates, representatives, licensors, suppliers, partners, advertisers and content providers, harmless from and against any claims, actions, demands, liabilities and settlements including without limitation, reasonable legal and accounting fees, arising out of or resulting from, or alleged to result from, your violation of this Agreement.</p>



<h2>29 DISPUTE RESOLUTION AND ARBITRATION</h2>

<p>PLEASE READ THIS SECTION CAREFULLY BECAUSE IT REQUIRES YOU TO ARBITRATE CERTAIN DISPUTES AND CLAIMS WITH US AND LIMITS THE MANNER IN WHICH YOU MAY SEEK RELIEF FROM US.</p>

<p>29.1. ARBITRATION:</p>

<p>To the fullest extent permitted under applicable law and in the interest of resolving disputes between you and the Company in an expedient and cost-effective manner, you and the Company agree that any dispute, claim or controversy arising out of or relating to this Agreement (collectively, "Disputes") shall be settled by binding individual arbitration under the Consumer Arbitration Rules of the American Arbitration Association (the "AAA Rules") then in effect, except as modified in this Agreement. The AAA Rules and filing forms are available online at <a href="http://www.adr.org" target="_blank" rel="noreferrer noopener">www.adr.org</a>.</p>

<p>29.2. If you are a resident of any European Union country or the United Kingdom, Switzerland, Norway or Iceland, the governing law and forum shall be the laws and courts of your usual place of residence.</p>

<p>29.3. SMALL CLAIMS COURT:</p>

<p>As an alternative to arbitration, you and the Company each retain the right to bring any Dispute in any small claims court with jurisdiction over the Dispute.</p>

<p>29.4. PLACE OF ARBITRATION / CONDUCT OF HEARING(S):</p>

<p>If you reside in the United States, then the place of the arbitration shall be, at your option, either (a) the state where you reside, or (b) New Castle County, Delaware. If you reside outside the United States, then the Arbitrator shall determine the place of arbitration based on the factors stated in the AAA Rules. Regardless of the place of arbitration, the Company agrees that any required arbitration hearing(s) may be conducted, at your option, by phone or video conference rather than in person. The arbitration may also be decided solely on the submission of documents to the Arbitrator, if you and the Company both so agree (which agreement must be made in writing and provided to the Arbitrator). The procedural law applicable to the conduct of the arbitration shall be the law of the place of arbitration and the AAA Rules. The Federal Arbitration Act shall govern all arbitration proceedings (and any related and/or resulting court proceedings) in the United States.</p>

<p>29.5. NOTICE OF DISPUTE / INFORMAL SETTLEMENT EFFORTS:</p>

<p>At least 30 days prior to initiating an arbitration, you and the Company each agree to notify the other party of the dispute in writing (the "Notice of Dispute") and attempt in good faith to negotiate an informal resolution. You must send your Notice of Dispute to: 101 Primrose Path, Mill Valley, CA 94941. The Company will send any Notice of Dispute to the email address associated with your Account. A Notice of Dispute must include: the name of the person bringing the Dispute and that person's preferred contact information, a brief description of the dispute, and the relief sought. If you and the Company are unable to resolve the dispute within the 30-day period, only then may either party commence arbitration by filing a written Demand for Arbitration (see <a href="http://www.adr.org" target="_blank" rel="noreferrer noopener">www.adr.org</a>) with the American Arbitration Association and providing a copy to the other party as specified in the AAA Rules.</p>

<p>29.6. ARBITRATION FEES AND COSTS:</p>

<p>Your share of administrative fees and arbitrator fees and costs (collectively, "Arbitration Costs") shall be governed by the AAA Rules. Either party may request the Arbitrator to award the requesting party some or all of its attorneys' fees and costs (in addition to some or all of its Arbitration Costs) upon proving that the other party has asserted a claim, cross-claim, or defense that is groundless in fact or law, brought in bad faith or for the purpose of harassment, or is otherwise frivolous, pursuant to applicable law and the AAA Rules.</p>

<p>29.7. FORM, EFFECT, AND SCOPE OF ARBITRATION AWARD:</p>

<p>The Arbitrator's judgment and award shall be final, binding and enforceable, subject to review only in accordance with applicable law governing the enforcement and annulment of arbitration awards. Judgment on the Award may be entered in any court with proper jurisdiction, pursuant to applicable law. The Arbitrator may award any relief allowed by law or the AAA Rules, but declaratory or injunctive relief may be awarded only on an individual basis to the extent necessary to provide relief warranted by the claimant's individual claim.</p>

<p>29.8. ARBITRATION OPT-OUT:</p>

<p>You can decline this agreement to arbitrate by sending a written communication to U4U Teen, 101 Primrose Path, Mill Valley, CA 94941, postmarked within 30 days after first accepting this Agreement. Your written communication must provide your name and the email address associated with your Account and must state that you decline this arbitration agreement.</p>

<p>29.9. CHANGES:</p>

<p>If the Company changes this Section 29 after the date you last accepted this Agreement (or accepted any subsequent changes to this Agreement), you may reject that change by sending us written notice to U4U Teen, 101 Primrose Path, Mill Valley, CA 94941, postmarked within 30 days of the date on which the change is effective. Rejecting a change, however, does not revoke or alter your prior consent to any earlier agreement to arbitrate any Dispute between you and the Company (or your prior consent to any subsequent changes thereto), which will remain in effect and enforceable as to any Dispute between you and the Company.</p>

<p>29.10. COURT PROCEEDINGS:</p>

<p>Consistent with the AAA Rules and applicable law, nothing in this Section 29 will be deemed to waive, preclude, or otherwise limit the right of either party to (i) bring an individual action in small claims court, where such court has jurisdiction over the Dispute; (ii) seek injunctive or interim relief from a court with jurisdiction to provide such relief; (iii) seek aid in support of the arbitration under applicable law; or (iv) seek to enforce or vacate (in whole or in part) the award under applicable law. If applicable law does not allow the arbitration of Disputes under this Agreement, then either you or the Company may instead commence dispute resolution proceedings in any court that has jurisdiction over the Dispute, and where venue is proper, subject to the terms of Section 29.13(i-iii) below and all terms outlined in Sections 1-28 and 30-34.</p>

<p>29.11. WAIVER OF JURY TRIAL:</p>

<p>IN ADDITION, TO THE FULLEST EXTENT PERMITTED UNDER APPLICABLE LAW, YOU AND THE COMPANY UNCONDITIONALLY WAIVE ANY RESPECTIVE RIGHTS TO A JURY TRIAL.</p>

<p>29.12. ADDITIONAL PROVISIONS APPLICABLE TO ALL DISPUTE RESOLUTION:</p>

<p>The following additional provisions are applicable to the resolution of all Disputes, to the fullest extent allowed by applicable law, regardless of whether brought in arbitration, court, or any other type of formal dispute resolution proceeding:</p>

<p>(i) Time Limitation:</p>

<p>Any Dispute shall be time-barred unless the party asserting the Dispute commences formal dispute resolution proceedings within one (1) year after the basis for such Dispute became known or should have become known to the party asserting the Dispute, provided, however, that the one-year period shall be deemed suspended during any informal settlement discussions following the receipt of a Notice of Dispute by any party pursuant to Section 29.5 above.</p>

<p>(ii) NO CLASS OR REPRESENTATIVE ACTIONS OR PROCEEDINGS:</p>

<p>TO THE FULLEST EXTENT PERMITTED UNDER APPLICABLE LAW, YOU AND THE COMPANY AGREE THAT EACH MAY BRING DISPUTES AGAINST THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING.</p>

<p>(iii) No Consolidation:</p>

<p>You and the Company acknowledge and agree that, to the fullest extent permitted by law, we are each waiving the right to participate in a consolidated proceeding.</p>



<h2>30 GOVERNING LAW</h2>

<p >30.1. To the fullest extent permitted pursuant to applicable law, this Agreement shall be governed by the laws of the State of Delaware, U.S.A. (to the exclusion of its conflict of law rules).</p>



<h2>31 NOTICE AND TAKEDOWN PROCEDURES</h2>

<p>31.1. If you believe any materials accessible on or from the App infringe your copyright, you may request removal of those materials (or access thereto) from this App by contacting the Company and providing the following information:</p>

<p>31.1.1. Identification of the copyrighted work that you believe to be infringed. Please describe the work, and, where possible, include a copy or the location of an authorized version of the work.</p>

<p>31.1.2. Identification of the material that you believe to be infringing and its location. Please describe the material, and provide us with its URL or any other pertinent information that will allow us to locate the material.</p>

<p>31.1.3. Your name, address, telephone number and (if available) e-mail address.</p>

<p>31.1.4. A statement that you have a good faith belief that the complained use of the materials is not authorized by the copyright owner, its agent, or the law.</p>

<p>31.1.5. A statement that the information that you have supplied is accurate, and indicating that "under penalty of perjury," you are the copyright owner or are authorized to act on the copyright owner's behalf.</p>

<p>31.1.6. A signature or the electronic equivalent from the copyright holder or authorized representative.</p>

<p>In an effort to protect the rights of copyright owners, the Company maintains a policy for the termination, in appropriate circumstances, of subscribers and account holders of the App who are repeat infringers.</p>



<h2>32 DATA RETENTION AND ACCOUNT TERMINATION</h2>

<p>32.1. Data Retention Periods</p>

<p>We retain different types of data for different periods. The blow periods may change, yet represent the standard goal:</p>

<p>Account Information: Retained while account is active, plus 90 days after deletion (to allow account recovery and comply with legal obligations)</p>

<p>Messages in Houses: Retained for 1 year after posting or until account deletion, whichever comes first</p>

<p>Mood Tracking Data: Retained for 2 years or until deletion requested, whichever comes first</p>

<p>Photos/Images: Retained until user deletes them or account is closed, plus 30 days in backup systems</p>

<p>Usage Analytics: Retained in aggregate, de-identified form indefinitely for platform improvement</p>

<p>Backup Systems: Deleted data may remain in backup systems for up to 90 days but will not be accessible or used</p>

<p>For users under 13: Parents can request deletion of any or all data at any time. We will comply within 30 days unless retention is required by law.</p>

<p>32.2. Account Termination by User</p>

<p>You may delete your account at any time by:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Requesting deletion through the app via messaging either â€˜technical supportâ€™ or your house lead</li>
<li>Contacting us at <a data-auto-recognition="true" href="mailto:team@u4uteen.com" >team@u4uteen.com</a></li>
</ul>

<p>Upon account deletion:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>You will immediately lose access to your account</li>
<li>Your data will be deleted according to the retention periods above</li>
<li>You may request an export of your data within 7 days of deletion request</li>
<li>Deletion does not erase messages that other users received from you (they retain their copies)</li>
<li>Any active subscriptions will be canceled (subject to refund policy in Section 13)</li>
</ul>

<p>32.3. Account Termination by U4U</p>

<p>We may suspend or terminate your account at any time if:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>You violate these Terms</li>
<li>You violate our Community Guidelines</li>
<li>You engage in illegal activity</li>
<li>You pose a safety risk to yourself or others</li>
<li>You provide false information (including false age)</li>
<li>We are required to do so by law</li>
<li>We cease operating the App</li>
</ul>

<p>Immediate termination without warning may occur for:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Child sexual abuse material (CSAM)</li>
<li>Threats of violence or harm</li>
<li>Severe harassment or bullying</li>
<li>Illegal activity</li>
<li>Multiple serious violations</li>
<li>Providing false age information</li>
</ul>

<p>32.4. Effect of Termination</p>

<p>Upon termination of your account:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Your access to the App immediately ends</li>
<li>Your data is subject to deletion per our retention policy</li>
<li>Outstanding payment obligations remain due</li>
<li>Provisions of this Agreement that should survive (including Sections 21, 22, 28, 29, 30) continue to apply</li>
</ul>

<p>32.5. Appeals</p>

<p>If your account is terminated by U4U, you may appeal by:</p>

<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
<li>Sending an email to <a data-auto-recognition="true" href="mailto:team@u4uteen.com" >team@u4uteen.com</a> within 7 days</li>
<li>Including your username and explanation</li>
<li>Providing any relevant information</li>
</ul>

<p>We will review and respond within 5 business days. Our decision on appeals is final.</p>

<p>Accounts terminated for CSAM, threats of violence, or illegal activity are not eligible for appeal.</p>

<h2>&nbsp;</h2>

<h2>33 OTHER PROVISIONS</h2>

<p>33.1. Modification of Terms</p>

<p>We may modify this Agreement from time to time if we think it is necessary (e.g. for legal reasons or to reflect changes in the App, website). If we materially change the Agreement, we will make the updated Agreement available online and make reasonable efforts to tell you about it (e.g. by sending you a notice via email or in-app notification).</p>

<p>Once we change the Agreement, it will become legally binding on you thirty (30) days after we post it online. During that period, you are welcome to contact us at <a data-auto-recognition="true" href="mailto:team@u4uteen.com" >team@u4uteen.com</a> if you have specific questions about the changes.</p>

<p>If you don't agree to the new terms, you should stop using our services and delete your account. Your continued use of the services after the effective date of an updated version of the Agreement will indicate your acceptance of the Agreement as modified.</p>

<p>33.2. Successors and Assigns</p>

<p>This agreement ensures the benefit of the parties, including any of our successors in interest. We have the right to assign our rights and obligations under this agreement to any affiliates or to any other entity.</p>

<p>33.3. Severability</p>

<p>If for any reason an arbitrator, an arbitral or other tribunal, or a court of competent jurisdiction finds any provision of this Agreement, or any portion thereof, to be unenforceable, that provision shall be enforced to the maximum extent permissible so as to affect the intent of this Agreement, and the remainder of this Agreement shall continue in full force and effect. A printed version of this Agreement shall be admissible in arbitral, judicial or administrative proceedings.</p>

<p>33.4. No Waiver</p>

<p>No waiver by the Company of any term or condition set forth in this Agreement shall be deemed a further or continuing waiver of such term or condition or a waiver of any other term or condition, and any failure of the Company to assert a right or provision under this Agreement shall not constitute a waiver of such right or provision.</p>

<p>33.5. Survival</p>

<p>Upon termination of this Agreement, all provisions of this Agreement that by their nature, should survive termination, shall survive termination, including, without limitation, the provisions on dispute resolution and arbitration, all ownership provisions, warranty disclaimers, and limitations of liability.</p>

<p>33.6. Entire Agreement</p>

<p>These Terms, together with the Privacy Policy and Community Guidelines, constitute the entire agreement between you and U4U regarding the use of the App and supersede any prior agreements between you and U4U relating to your use of the App.</p>

<p>33.7. Language</p>

<p>This Agreement is written in English. Any translations are provided for convenience only. In the event of any conflict between the English version and a translated version, the English version shall prevail.</p>



<h2>34 QUESTIONS, COMPLAINTS AND COMMENTS</h2>

<p>34.1. If you have any comments or questions on any part of the App or any part of these Terms of Use, require support, or have any claims, please contact us at <a data-auto-recognition="true" href="mailto:team@u4uteen.com" >team@u4uteen.com</a>.</p>

<p>For residents of California, in accordance with California Civil Code Â§ 1789.3, you may also report complaints to the Complaint Assistance Unit of the Division of Consumer Services of the California Department of Consumer Affairs by contacting them in writing at 400 R Street, Sacramento, CA 95814, or by telephone at (800) 952-5210.</p>

<p>The registered office of U4U Teen is 101 Primrose Path, Mill Valley, CA 94941.</p>

<p>34.2. When you contact us, we expect our staff to be polite and respectful. We expect the same of you. If you are rude to or abuse or threaten our staff we may restrict you to contacting us by email or refuse to support you any further. If your behavior suggests a risk to our staff, our community or our business we may suspend your account and escalate the matter to law enforcement.</p>



<h2>ACKNOWLEDGMENT</h2>

<p>BY CREATING AN ACCOUNT, VERIFYING AN ACCOUNT, SUBSCRIBING, OR USING THE U4U APP, YOU ACKNOWLEDGE THAT YOU HAVE READ THESE TERMS OF USE AND AGREE TO BE BOUND BY THEM.</p>





<p >These Terms of Use constitute a legally binding agreement. Please read them carefully before using U4U.</p>

<p>U4U Teen<br />
101 Primrose Path<br />
Mill Valley, CA 94941<br />
team@u4uteen.com<br />
(707) 789-1253</p>

<h2>U4U Terms of Use (End User License Agreement)</h2>
<p>Effective Date: April 1, 2026</p>
<p>
  Welcome to U4U. These Terms of Use ("Terms") govern your access to and use
  of the U4U mobile application, website, and related services (collectively,
  the "App"), operated by U4U Inc. ("U4U," "we," "our," or "us").
</p>
<p>
  By creating an account, accessing, or using the App, you agree to be bound
  by these Terms. If you do not agree, you may not use the App.
</p>

<h3>1. Eligibility</h3>
<p>
  U4U is designed for female users ages 11-18, with additional features for
  parents or guardians. By using the App, you confirm that:
</p>
<ul>
  <li>You meet the applicable age requirements</li>
  <li>If required, you have permission from a parent or legal guardian</li>
</ul>

<h3>2. License to Use the App</h3>
<p>
  U4U grants you a limited, non-exclusive, non-transferable, revocable license
  to use the App for personal, non-commercial purposes, subject to these Terms.
</p>
<p>You agree not to:</p>
<ul>
  <li>Copy, modify, or distribute the App</li>
  <li>Reverse engineer or attempt to extract source code</li>
  <li>Use the App for any unlawful or harmful purpose</li>
</ul>

<h3>3. User-Generated Content</h3>
<p>
  The App may allow users to create, post, or share content ("User Content"),
  including messages, responses, or other interactions.
</p>
<p>By submitting User Content, you:</p>
<ul>
  <li>Retain ownership of your content</li>
  <li>
    Grant U4U a limited license to use, display, and distribute your content
    within the App to provide and improve services
  </li>
</ul>
<p>
  You are solely responsible for your User Content and any consequences of
  sharing it.
</p>

<h3>4. Safety &amp; Community Standards (Zero Tolerance Policy)</h3>
<p>
  U4U is committed to maintaining a safe, supportive, and respectful
  environment, especially for teen users. We have zero tolerance for
  objectionable content or abusive behavior.
</p>
<p>The following are strictly prohibited:</p>
<ul>
  <li>Bullying, harassment, or intimidation</li>
  <li>Hate speech or discriminatory content</li>
  <li>Sexual, explicit, or inappropriate content</li>
  <li>Content promoting self-harm, violence, or dangerous behavior</li>
  <li>Spam, scams, or misleading content</li>
  <li>Any content that is illegal or harmful</li>
</ul>
<p>U4U reserves the right to:</p>
<ul>
  <li>Remove any content that violates these standards</li>
  <li>
    Suspend or permanently ban users who engage in prohibited behavior
  </li>
  <li>Report unlawful activity to appropriate authorities</li>
</ul>

<h3>5. Reporting &amp; Moderation</h3>
<p>
  Users can report content or behavior that violates these Terms within the app
  through the messaging page or by emailing team@u4uteen.com. U4U reviews
  reports and takes appropriate action, which may include content removal or
  account suspension.
</p>
<p>We actively moderate content to maintain a safe environment.</p>

<h3>6. Parental Features</h3>
<p>
  For parent or guardian accounts, U4U may provide insights or guidance related
  to a child's experience. Parents agree to use this information responsibly and
  in support of their child's well-being. Expanded and detailed terms are
  present in our complete terms and conditions: https://www.u4uteen.com/terms-conditions
</p>

<h3>7. Privacy</h3>
<p>
  Your use of the App is also governed by our Privacy Policy, which explains
  how we collect, use, and protect your information:
  https://www.termsfeed.com/live/32a5fb9a-77ce-4c64-89c4-35c77b1d40b0
</p>

<h3>8. No Medical or Clinical Advice</h3>
<p>
  U4U provides wellness, educational, and supportive content. It is not a
  substitute for professional medical, psychological, or psychiatric advice,
  diagnosis, or treatment. If you are experiencing a crisis, please contact 911
  or a qualified professional or emergency services.
</p>

<h3>9. Termination</h3>
<p>
  We may suspend or terminate your access to the App at any time if you violate
  these Terms or if we determine your use poses a risk to others or the
  platform. You may stop using the App at any time.
</p>

<h3>10. Disclaimer of Warranties</h3>
<p>
  The App is provided "as is" and "as available." U4U makes no guarantees
  regarding:
</p>
<ul>
  <li>Continuous availability</li>
  <li>Accuracy or completeness of content</li>
  <li>Suitability for a particular purpose</li>
</ul>

<h3>11. Limitation of Liability</h3>
<p>
  To the fullest extent permitted by law, U4U shall not be liable for any
  indirect, incidental, or consequential damages arising from your use of the
  App.
</p>

<h3>12. Changes to These Terms</h3>
<p>
  We may update these Terms from time to time. Continued use of the App after
  changes means you accept the updated Terms.
</p>

<h3>13. Contact Us</h3>
<p>If you have questions or concerns, please contact us at:</p>
<p>team@u4uteen.com or through the website: www.u4uteen.com</p>


      </div>
    </div>
  );
};

export default TermsConditions;

